import { i18n } from '@apps/main/modules/localization/localizationSetup';

const { t } = i18n.global;

export const enum ActivitySelectionFilter {
  ActivityName = 'activityName',
  TypeTickets = 'types.tickets',
  TypeGolf = 'types.golf',
}

export interface ActivityNameFilterUpdate {
  type: ActivitySelectionFilter.ActivityName;
  value: string;
}

export interface ActivityTypeTicketsFilterUpdate {
  type: ActivitySelectionFilter.TypeTickets;
  value: boolean;
}

export interface ActivityTypeGolfFilterUpdate {
  type: ActivitySelectionFilter.TypeGolf;
  value: boolean;
}

export type ActivitySelectionFilterUpdate =
  | ActivityNameFilterUpdate
  | ActivityTypeTicketsFilterUpdate
  | ActivityTypeGolfFilterUpdate;

export interface ActivitySelectionFiltersForm {
  activityName: string;
  types: ActivityTypesFilterSection;
}

export interface ActivityTypesFilterSection {
  tickets: boolean;
  golf: boolean;
}

export const DEFAULT_ACTIVITY_SELECTION_FILTERS: ActivitySelectionFiltersForm =
  {
    activityName: '',
    types: { tickets: false, golf: false },
  };

export interface ActivitySelectionFilterPillData {
  type: ActivitySelectionFilter;
  text: string;
}

export interface ActivitySelectionFilterPillConfig {
  type: ActivitySelectionFilter;
  textFactory: (filters: ActivitySelectionFiltersForm) => string;
}

export const DEFAULT_ACTIVITY_SELECTION_FILTER_UPDATE: Record<
  ActivitySelectionFilter,
  ActivitySelectionFilterUpdate
> = {
  [ActivitySelectionFilter.ActivityName]: {
    type: ActivitySelectionFilter.ActivityName,
    value: '',
  },
  [ActivitySelectionFilter.TypeTickets]: {
    type: ActivitySelectionFilter.TypeTickets,
    value: false,
  },
  [ActivitySelectionFilter.TypeGolf]: {
    type: ActivitySelectionFilter.TypeGolf,
    value: false,
  },
};

export const ALL_ACTIVITY_SELECTION_FILTERS = [
  ActivitySelectionFilter.ActivityName,
  ActivitySelectionFilter.TypeTickets,
  ActivitySelectionFilter.TypeGolf,
];

export const ACTIVITY_SELECTION_FILTER_PILLS_CONFIG: Record<
  ActivitySelectionFilter,
  ActivitySelectionFilterPillConfig
> = {
  [ActivitySelectionFilter.ActivityName]: {
    type: ActivitySelectionFilter.ActivityName,
    textFactory: () => t('filter.filter_by_name'),
  },
  [ActivitySelectionFilter.TypeTickets]: {
    type: ActivitySelectionFilter.TypeTickets,
    textFactory: () => t('filter.activityTypes.tickets'),
  },
  [ActivitySelectionFilter.TypeGolf]: {
    type: ActivitySelectionFilter.TypeGolf,
    textFactory: () => t('filter.activityTypes.golf'),
  },
};
